import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import 'cropperjs/dist/cropper.css';

import Cropper from 'cropperjs';
import PlusMinusControls from './PlusMinusControls';

class ImageCropDiv extends PureComponent {
    constructor(props) {
        super(props);
        this.activateCropper = this.activateCropper.bind( this );
        this.changedImage = this.changedImage.bind( this );
        this.cropImage = this.cropImage.bind( this );

        this.state = {
            cropperReady: false,
            isConverting: false,
        };
    }
    componentDidMount() {
        const { childRef } = this.props;
        if( childRef ) {
            childRef( this );
        }
    }
    componentWillUnmount() {
        const { childRef } = this.props;
        if( childRef ) {
            childRef( undefined );
        }
    }
    activateCropper() {
        this.cropper = new Cropper( this._cropImage,
            {
                viewMode: 0,
                aspectRatio: this.props.aspectRatio,
                checkOrientation: false,
                autoCropArea: 1,
                checkCrossOrigin: false,
                ready: () => {
                    this.setState( { cropperReady: true } );
                    if( this.props.ready ) {
                        this.props.ready();
                    }
                },
            });
    }
    changedImage() {
        // this.cropper.replace( newImage, false )
        this.cropper.destroy();
        // this.activateCropper();
    }
    cropImage() {
        if( this.state.cropperReady ) {
            this.setState( { isConverting: true } );
            if( this.props.loading ) {
                this.props.loading( true );
            }
            return new Promise( ( resolve ) => {
                var imageData = this.cropper.getImageData();
                var largeSide = Math.max( imageData.naturalWidth, imageData.naturalHeight );
                var conversion = Math.min( ( 1600/largeSide ), 1 );
                var canvasOptions = { fillColor: 'white' };
                if( conversion < 1 ) {
                    if( imageData.naturalWidth >= imageData.naturalHeight ) {
                        canvasOptions.width = 1600;
                    } else {
                        canvasOptions.height = 1600;
                    }
                }
                var croppedCanvas = this.cropper.getCroppedCanvas( canvasOptions );
                var imageDataUrl = croppedCanvas.toDataURL( 'image/jpeg', conversion );
                resolve( imageDataUrl );
            } )
            .then( ( imageDataUrl ) => {
                this.setState( { isConverting: false } );
                if( this.props.loading ) {
                    this.props.loading( false );
                }
                return imageDataUrl;
            } );
        }
        return new Promise.reject();
    }
    getCropData = () => {
        if( this.state.cropperReady ) {
            this.setState( { isConverting: true } );
            if( this.props.loading ) {
                this.props.loading( true );
            }
            var canvasData = this.cropper.getData();
            var cropData =  {
                'x_start': canvasData.x,
                'y_start': canvasData.y,
                'width': canvasData.width,
                'height': canvasData.height,
                'resize': 1,
            };
            return cropData;
        }
        return { error: true };
    }
    zoomIn = () => {
        if( this.state.cropperReady ) {
            this.cropper.zoom( 0.1 );
        }
    }
    zoomOut = () => {
        if( this.state.cropperReady ) {
            this.cropper.zoom( -0.1 );
        }
    }



    render() {
        const { src } = this.props;
        return (
            <div className={ this.props.className } style={ { position: 'relative' } }>
                <img src={ src } ref={ ( el ) => { this._cropImage = el; } } onLoad={ this.activateCropper } />
                <PlusMinusControls zoomIn={ this.zoomIn } zoomOut={ this.zoomOut } />
            </div>
        );
    }
}
ImageCropDiv.propTypes = {
    src: PropTypes.string.isRequired,
};

export default ImageCropDiv;
